import { AfterViewInit, Component, ElementRef, QueryList, ViewChildren, OnInit  } from '@angular/core';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { PayrollDetailComponent } from '../payroll-detail/payroll-detail.component';
import { PayrollInfoComponent } from '../payroll-info/payroll-info.component';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoginService } from 'src/app/shared/services/authservices/login.service';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import Swal from 'sweetalert2';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';
import { AddService } from 'src/app/shared/services/userservices/add.service';
declare let $: any;
@Component({
  selector: 'app-payroll-main',
  imports: [LoaderComponent, PayrollDetailComponent, PayrollInfoComponent,CommonModule, FormsModule, RouterModule, LoaderComponent],
  templateUrl: './payroll-main.component.html',
  styleUrl: './payroll-main.component.css'
})
export class PayrollMainComponent implements OnInit, AfterViewInit  {
 public showSpinner = false;
  otpArray: string[] = ['', '', '', '', '', '']; 
  forgotOtpArray: string[] = ['', '', '', '']; 
  // New PIN OTP
  newPinOtpArray: string[] = ['', '', '', '', '', ''];

  // Confirm PIN OTP
  confirmPinOtpArray: string[] = ['', '', '', '', '', ''];
  newPin = "";
confirmPin = "";
pinsMatch = false;
  isStar  = true;
  otpValue = '';
  user: any;
 salaries: any[] = [];
 lastSalary: any;
  isLoading = true;
 userSalaryUpcoming: any = null;
    pieChartData: any[] = [];
  selectedYear!: number;

 selectedTab: 'monthly' | 'yearly' = 'monthly';  // <-- Add this line

  years: number[] = [];
  salarySummary: any = {
    monthlySalary: [25000, 28000, 26000, 30000, 31000, 32000, 29000, 33000, 30000, 34000, 35000, 36000],
    yearlySalary: [300000, 320000, 310000, 330000, 340000, 350000, 360000, 370000, 380000, 390000, 400000, 410000],
    categoriesMonthly: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    categoriesYearly: ['2014','2015','2016','2017','2018','2019','2020','2021','2022','2023','2024','2025'],
    pieChartData: [
      { name: 'Total Earning', percentage: 70, fill: '#B287D4' },
      { name: 'Total Deduction', percentage: 20, fill: '#56CED6' },
      { name: 'Total Tax', percentage: 5, fill: '#4396D2' },
      { name: 'Remaining', percentage: 5, fill: '#A0C4FF' }
    ],
    totalEarning: 2555

  }


  constructor(
    private mediaService: MediaService,
    private _loginService: LoginService,
    public payrollService: PayrollService,
     private addService: AddService,
    public router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private activatedRoute: ActivatedRoute
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');

  }

  ngOnInit(): void {
      if (typeof $ !== 'undefined') {
      console.log('✅ jQuery is loaded:', $.fn.jquery);
    } else {
      console.error('❌ jQuery is NOT loaded.');
    }
    
     // Wait until DOM is fully ready
  // setTimeout(() => {
  //   this.checkModalDisplay();
  // }, 0);
   

  const previousRoute = sessionStorage.getItem('previousRoute') || '';
  const currentRoute = this.router.url;

  const payrollRoutes = ['/payroll-main', '/payroll-list', '/payroll-sheet'];

  // Detect refresh
  const isRefresh = previousRoute === currentRoute || previousRoute === '';

  if (isRefresh) {
    this.isStar = true;
    sessionStorage.setItem('isStar', 'true');
  }
  else if (!payrollRoutes.includes(previousRoute)) {
    // Coming from outside payroll
    this.isStar = true;
    sessionStorage.setItem('isStar', 'true');
  } 
  else {
    // inside payroll section → restore saved
    const saved = sessionStorage.getItem('isStar');
    this.isStar = saved ? JSON.parse(saved) : true;
  }
 
  // this.checkModalDisplay();


    this.hideModal();
  }
ngAfterViewInit(): void {
    // Delay to make sure DOM is rendered
    setTimeout(() => {
      this.checkModalDisplay();
    }, 50);
  }
  
private checkModalDisplay() {
  const excluded = ['/payroll-main', '/payroll-list', '/payroll-sheet'];
  const previousRoute = sessionStorage.getItem('previousRoute') || '';

  // show modal only if previous route is not in excluded list OR on refresh
  const showModal = !excluded.some(route => previousRoute.includes(route));

  if (showModal) {
    $('#payrollModal').modal('show');
    $('#payrollModal').modal({ backdrop: 'static', keyboard: false });
  } else {
    $('#payrollModal').modal('hide');
    this.getAllPayroll();
  }
}

 

    getAllPayroll(month?: string, year?: number) {
      this.payrollService.getPayroll(month, year).then((value) => {
      if(value == undefined){
          Swal.fire({
              iconHtml: ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
              title: 'No Data Found',
              showConfirmButton: false,
              timer: 1500,  
            }).then(() => {
              this.router.navigate(['/dashboard-1']);
            });
             
            
      }
      if (value.success == true) {
        this.salaries = value.data
         if (this.salaries.length > 0) {
            this.lastSalary = this.salaries[0];
            console.log('last entery', this.lastSalary)
          }
        this.calculatePayroll(this.user.id)
        
      }
      else {
            Swal.fire({
              iconHtml: ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
              title: value.message,
              showConfirmButton: false,
              timer: 3000,  
            });
             setTimeout(() => {
             ($('#payrollModal') as any).modal('show');;
          }, 200);
           
          }
    });
  }


calculatePayroll(id: any) {

    this.addService.userComingSalary(id).then((value) => {
      this.userSalaryUpcoming = value;
      this.payrollSummary('monthly');
    });
  }




 hideModal() {
    $('#payrollModal').modal('hide');
  }




  payrollSummary(type: 'monthly' | 'yearly') {
    const year = this.selectedYear; // use selected year if available

    this.payrollService.getPayrollSummary(type, year).then((value) => {
      if (value.success) {
        this.salarySummary = value.data;
        this.pieChartData = this.salarySummary.pieChartData;
        this.isLoading = false;
      }
    });

  }

  // Receive year from child
  onYearSelected(year: number) {
    this.selectedYear = year;
    this.payrollSummary('monthly'); // or 'yearly', depending on your tab
  }








 trackByIndex(index: number, item: any) {
    return index;
  }

  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;

    // Keep only the first character
    const char = input.value.charAt(0) || '';
    this.otpArray[index] = char;

    // Force input value to prevent duplication
    input.value = char;

    // Move to next field if not last
    if (char && index < this.otpArray.length - 1) {
      const nextInput = input.nextElementSibling as HTMLInputElement;
      nextInput?.focus();
    }


    const allFilled = this.otpArray.every(val => val !== '');
    if (allFilled) {
      // Slight delay to ensure input model updates before calling submit
      setTimeout(() => {
        this.matchOtpPayrol();
      }, 10);
    }
  }

  onKeyUp(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    // Backspace navigation
    if (!input.value && event.key === 'Backspace' && index > 0) {
      const prevInput = input.previousElementSibling as HTMLInputElement;
      prevInput?.focus();
    }
  }

  matchOtpPayrol() {
    const otpValue = this.otpArray.join('');
    if (otpValue.length === 6) {
     this.otpForm(otpValue);
    } else {
      this.inputerror("Please enter all 6 digits!");
    }
  }

  
  allowNumbersOnly(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;
  // Allow only numbers 0-9
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}


  
 otpForm(picode: any) {

  const pincode = picode;
  
  this._loginService.checkPincode(this.user.email, pincode)
    .then((value) => {
      
      if (value.success == true) {
        $('#payrollModal').modal('hide');
        // Show success SweetAlert
        this.getAllPayroll(); 
      } else {
        // Invalid pincode → shake & clear inputs
        this.inputerror(value.message);
      }
    });
}
  
inputerror(message: string) {
  // Add shake class to all OTP inputs
  const otpInputs = document.querySelectorAll<HTMLInputElement>('.otp-input');
  otpInputs.forEach(input => {
    input.classList.add('shake', 'error'); // add shake & error class
    input.value = ''; // clear input
  });

  // Remove shake class after animation ends
  setTimeout(() => {
    otpInputs.forEach(input => {
      input.classList.remove('shake');
    });
  }, 500); // duration should match CSS animation

  // Reset your otpArray
  this.otpArray = Array(this.otpArray.length).fill('');
}



onForgotOtpInput(event: Event, index: number) {
  const input = event.target as HTMLInputElement;

  // Keep only first character
  const char = input.value.charAt(0) || '';
  this.forgotOtpArray[index] = char;
  input.value = char;

  // Move focus to next input if not last
  if (char && index < this.forgotOtpArray.length - 1) {
    const nextInput = input.nextElementSibling as HTMLInputElement;
    nextInput?.focus();
  }

  // Check if all 4 digits are filled
  const allFilled = this.forgotOtpArray.every(val => val !== '');
  if (allFilled) {
    setTimeout(() => {
      this.verifyForgotOtp();
    }, 10); // slight delay to ensure Angular updates model
  }
}


// Handle backspace navigation
onForgotOtpKeyUp(event: KeyboardEvent, index: number) {
  const input = event.target as HTMLInputElement;
  if (!input.value && event.key === 'Backspace' && index > 0) {
    const prevInput = input.previousElementSibling as HTMLInputElement;
    prevInput?.focus();
  }
}

// Verify OTP
verifyForgotOtp() {
  
  const otp = this.forgotOtpArray.join('');
  if (otp.length === 4) {
   this.otpverification(otp);
  } else {
    alert('Please enter all 4 digits');
  }
}



 otpverification(otp: any) {
  ($('#forgotPasswordModal') as any).modal('hide');
  this._loginService.verifyOtp(otp).then((value) => {
    if (value.success === true) {
      // OTP success: you can still show some success animation if needed
      ($('#newPasswordModal') as any).modal('show');
    } else {
      // OTP failed → show red border and shake
      this.inputErrorForgot(value.message);
    }
  });
}

// Show red border, shake, and clear inputs
inputErrorForgot(message: string) {
  const otpInputs = document.querySelectorAll<HTMLInputElement>('.forget-otp-container .otp-input');
  otpInputs.forEach(input => {
    input.classList.add('shake', 'error'); // red border + shake
    input.value = ''; // clear input
  });

  // Reset array
  this.forgotOtpArray = Array(this.forgotOtpArray.length).fill('');

  // Remove shake class after animation
  setTimeout(() => {
    otpInputs.forEach(input => input.classList.remove('shake'));
  }, 500);
}
    







closeotpModal(){
  ($('#forgotPasswordModal') as any).modal('hide');
  ($('#newPasswordModal') as any).modal('show');

  
}



// Close modal
closeForgotPasswordModal() {
 ($('#payrollModal') as any).modal('hide');
 setTimeout(() => {
    ($('#payrollModal') as any).modal('show');
  }, 200); // sm
}





maskEmail(email: string): string {
  if (!email) return '';
  
  const [localPart, domain] = email.split('@');
  
  if (localPart.length <= 2) {
    return localPart[0] + '*'.repeat(localPart.length - 1) + '@' + domain;
  }
  
  const visibleChars = 2; // show first 2 chars
  const maskedPart = '*'.repeat(localPart.length - visibleChars);
  
  return localPart.substring(0, visibleChars) + maskedPart + '@' + domain;
}









    
    gotoDashboard() {
      const user_role = JSON.parse(this.user.user_role.user_roles)
      this.hideModal();
      if (user_role.role_type == "Employee") {
        this.router.navigate(['/dashboard-1']);
      } else {
        this.router.navigate(['/new-admin-dashboard']);
      }
    }


    updateIsStar(value: boolean) {
    this.isStar = value;
  }





  // Handle input
// onOtpInput(event: Event, index: number, otpArray: string[]) {
//   const input = event.target as HTMLInputElement;
//   const char = input.value.charAt(0) || '';
//   otpArray[index] = char;
//   input.value = char;

//   if (char && index < otpArray.length - 1) {
//     const nextInput = input.nextElementSibling as HTMLInputElement;
//     nextInput?.focus();
//   }
// }

onOtpInput(event: Event, index: number, otpArray: string[]) {
  const input = event.target as HTMLInputElement;
  const char = input.value.charAt(0) || '';
  otpArray[index] = char;
  input.value = char;

  // Move to next input if not last
  if (char && index < otpArray.length - 1) {
    const nextInput = input.nextElementSibling as HTMLInputElement;
    nextInput?.focus();
  }

  // Build full PIN strings
  const newPin = this.newPinOtpArray.join('');
  const confirmPin = this.confirmPinOtpArray.join('');

  // Enable Save button only if both 6 digits and match
  this.pinsMatch = newPin.length === 6 && confirmPin.length === 6 && newPin === confirmPin;
}



// Handle backspace navigation
onOtpKeyUp(event: KeyboardEvent, index: number, otpArray: string[]) {
  const input = event.target as HTMLInputElement;
  if (!input.value && event.key === 'Backspace' && index > 0) {
    const prevInput = input.previousElementSibling as HTMLInputElement;
    prevInput?.focus();
  }
}


gotoForgotPassword() {
 ($('#payrollModal') as any).modal('hide');
 ($('#forgot-otp-form .otp-input') as any).removeClass('error');

    this._loginService
    .sendOtp(this.user.email)
          .then((value) => {
            if (value.success == true) {      
                  setTimeout(() => {
                    ($('#forgotPasswordModal') as any).modal('show');
                  }, 200);
          
          } else {
             ($('#payrollModal') as any).modal('hide');
            Swal.fire({
              iconHtml: ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
              title: value.message,
              showConfirmButton: false,
              timer: 3000,  
            });
             setTimeout(() => {
             ($('#payrollModal') as any).modal('show');;
          }, 200);
           
          }
        });
  
}



// Verify New PIN
verifyNewPin() {
  const otp = this.newPinOtpArray.join('');
  this.newPin = otp;
  if (otp.length === 6) {
     ($('#newPasswordModal') as any).modal('hide');
     ($('#conformPasswordModal') as any).modal('show');

  } else {
      Swal.fire({
              iconHtml: ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
              title:'Please enter all 6 digits for PIN',
              showConfirmButton: false,
              timer: 3000,  
            });
  }
}

// Verify Confirm PIN
verifyConfirmPin() {
  
  const otp = this.confirmPinOtpArray.join('');
  this.confirmPin = otp;
  const newPin = (this.newPin || '').trim();
  const confirmPin = (this.confirmPin || '').trim();
  if (otp.length != 6) {
     ($('#conformPasswordModal') as any).modal('hide');
    Swal.fire({
              iconHtml: ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
              title:'Please enter all 6 digits for Confirm PIN',
              showConfirmButton: false,
              timer: 3000,  
            });
  } else if (newPin !== confirmPin) {
     ($('#conformPasswordModal') as any).modal('hide');
      Swal.fire({
              iconHtml: ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
              title:'Your Pincode did not match. Please try again.',
              showConfirmButton: false,
              timer: 3000,  
            }).then(() => {
            ($('#conformPasswordModal') as any).modal('show');
          });
  }else{
 
    this._loginService
    .setNewPin(otp)
          .then((value) => {
            if (value.success == true) {
              // Show SweetAlert success modal
              Swal.fire({
                iconHtml: ' <img src="../../../../assets/theme1/sucess-modal.png"  alt="image" >',
                title: 'New Pincode set successfully!',
                showConfirmButton: false,
                timer: 1000,  // SweetAlert will close automatically after 1500ms
              }).then(() => {
                // After SweetAlert closes, hide the payroll modal
              $('#payrollModal').modal('show');
            });
       
          } else {
            // If the verification fails, show the error message
            Swal.fire({
              iconHtml: ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
              title: 'Somthing Went Wrong! Please try again later.',
              showConfirmButton: false,
              timer: 3000,  // SweetAlert will close automatically after 3000ms
            });
          }
        });
     ($('#conformPasswordModal') as any).modal('hide');
     ($('#forgotPasswordModal') as any).modal('hide');
  }
}

    
}
